import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Radio, Space, Input, Row, Checkbox } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import "./location.filter.css";
import axios from "axios";
import {
  fetchKeySearchLocation,
  searchLocation,
  fetchStateSuggesionsInit,
  fetchKeySearchDynamicLocation,
} from "../../../../redux/actions";
import { debounce } from "../../../../shared/helpers";
import { useParams } from "react-router-dom";

const FilterState = (props) => {
  const dispatch = useDispatch();
  const { id, name } = useParams();
  const [stateValue, setStateValue] = useState([]);
  const [defaultValue, setDefaultValue] = useState();
  const [searchCountry, setSearchCountry] = useState("");
  const [searchtext, setSearch] = useState();
  const filters = useSelector(
    (state) => state.searchSkillListingReducer.filters
  );
  const locations = useSelector(
    (state) => state.searchSkillListingReducer.locations
  );
  const stateSuggestions = useSelector(
    (state) => state.searchSkillListingReducer.stateSuggestions
  );
  const [checkedItems, setCheckedItems] = useState([]);

  useEffect(() => {
    if (props.countryObj) {
      setDefaultValue(props.countryObj);
    }
  }, [props]);

  useEffect(() => {
    var options = [];
    if (stateSuggestions && stateSuggestions.location) {
      for (var i = 0; i < stateSuggestions.location.length; i++) {
        options = [
          // ...options,
          {
            value: stateSuggestions.location[i].CountryName,
            value2: stateSuggestions[i].CountryId,
            count:0,
          },
        ];
      }
      //append selected cities in suggestions array
      if (props.check && props.check.length > 0) {
        for (var j = 0; j < props.check.length; j++) {
          options = [
            {
              value: props.check[j].name,
              value2: props.check[j].id,
              count:0,
            },
            ...options,
          ];
        }
      }
      //creating unique array
      var uniqueArr = [];
      options.forEach((option) => {
        if (!uniqueArr.some((item) => item.value === option.value)) {
          uniqueArr.push(option);
        }
      });

      setStateValue(uniqueArr.sort((a, b) => a?.value?.toLowerCase()?.localeCompare(b?.value?.toLowerCase())));
    } else {
      setStateValue(options);
    }
  }, [stateSuggestions]);

  useEffect(() => {
    var options = [];
    if (stateSuggestions?.length > 0) {
      for (var i = 0; i < stateSuggestions?.length; i++) {
        options = [
          ...options,
          {
            value: stateSuggestions[i].CountryName,
            value2: stateSuggestions[i].CountryId,
            count: 0,
          },
        ];
      }
      //append selected cities in suggestions array
      if (props.check && props.check.length > 0) {
        for (var j = 0; j < props.check.length; j++) {
          options = [
            {
              value: props.check[j].name,
              value2: props.check[j].id,
              count: 0,
            },
            ...options,
          ];
        }
      }
      //creating unique array
      var uniqueArr = [];
      options.forEach((option) => {
        if (!uniqueArr.some((item) => item.value === option.value)) {
          uniqueArr.push(option);
        }
      });

      setStateValue(uniqueArr.sort((a, b) => a?.value?.toLowerCase()?.localeCompare(b?.value?.toLowerCase())));
    } else {
      setStateValue(options);
    }
  }, [stateSuggestions]);

  const onChange = (e) => {
    // let value = JSON.parse(e.target.value)
    const { value, value2, value3, count, checked } = e.target;

    if (e.target.checked) {
      props.setCheckCountryId((prev) => [...prev, parseInt(e.target.value2)]); // Add the value to the array
      props.setcheck((prev) => [
        ...prev,
        {
          name: e.target.value,
          id: parseInt(e.target.value2),
          count:0,
        },
      ]);
    } else {
      props.setCheckCountryId(
        props?.checkCountryId.filter((item) => item !== e.target.value2)
      ); // Remove the value from the array
      props.setcheck(
        props?.check.filter((item) => item.id !== e.target.value2)
      );
    }
    // props.setcheck(value.value);
    // props.setcountryObj(value)
    // props.setCheckCountryId(parseInt(value.value2));

    // if (props.addQuery) {
    //    props.addQuery('City', e.target.value)
    // }
  };

  const onLocationSearch = (value) => {
    if (Object.keys(props.searchLocationFilter).length) {
      props.searchLocationFilter.obj['CountryId'] = []
      setSearchCountry(value);
      const query = `country=${value}`;
      const params = {
        value: query,
        body: props.searchLocationFilter,
      };
      dispatch(fetchKeySearchDynamicLocation(params));
    } else {
      const obj = {
        value: value,
        type: "country",
      };
      const params = { obj };
      dispatch(fetchStateSuggesionsInit(params));
      // dispatch(fetchKeySearchDynamicLocation(value))
    }
  };

  useEffect(() => {
    if (props.emptyCountryInput == "" && !props.searchLocationFilter) {
      dispatch(fetchStateSuggesionsInit());
    }
  }, [props.emptyCountryInput]);

  const getCheckedValues = (value2) => {
    if (props.checkCountryId.includes(value2)) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <div className="location-suggestion-view" style={{ overflow: "auto" }}>
      <Input
        onChange={debounce((e) => onLocationSearch(e.target.value))}
        className="filter-search-input"
        placeholder="Search"
        value={props.emptyCountryInput}
        prefix={<SearchOutlined />}
      />
      {/* <Radio.Group onChange={onChange} className='location-radios-grp' value={props.locObj}> */}
      <Space direction="vertical" style={{ width: "98%" }}>
        {!searchtext ? (
          <div
            className={`location-lists-container ${
              stateValue?.length > 5 ? "show-scrollbar" : ""
            }`}
          >
            { stateValue?.length ? stateValue.map((items, index) => {
              return items?.value ? (
                <div
                  style={{
                    display: "flex",
                    width: "100%",
                    marginTop: index == 0 ? "0px" : "10px",
                  }}
                  key={index}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      width: "inherit",
                    }}
                  >
                    <Checkbox
                      checked={getCheckedValues(items.value2)}
                      onChange={onChange}
                      value={items.value}
                      value2={items.value2}
                      value3={items.value3}
                      count = {items.count}
                      key={index}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        {" "}
                        <div>{items.value}</div>{" "}
                      </div>
                    </Checkbox>
                    {/* {id || props?.fromCandMkt ? null : <> <div className="countDiv">({items?.count})</div> </>} */}
                  </div>
                </div>
              ) : null;
            }) : <div style={{display: 'flex', justifyContent: 'center', color: '#7e7e7e'}}> No results found </div> }
          </div>
        ) : (
          searchtext.map((items, index) => {
            return (
              <Checkbox
                checked={getCheckedValues(items.value2)}
                onChange={onChange}
                value={items.value}
                value2={items.value2}
                value3={items.value3}
                count = {items.count}
                key={index}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  {" "}
                  <div>{items?.value}</div> 
                  {/* { id || props?.fromCandMkt ? null : <> <div className="countDiv">({items?.count})</div> </> } */}
                </div>
              </Checkbox>
            );
          })
        )}
      </Space>
      {/* </Radio.Group> */}
    </div>
  );
};
export default FilterState;
